document.addEventListener('DOMContentLoaded', () => {

  const menu =
    document.querySelector('[data-nmh]');

  const header =
    document.querySelector('header-component');


  if (!menu || !header) return;


  /* ==========================================
     IDENTIFICA HOME
  ========================================== */

  const isHome =
    document.body.classList.contains(
      'template-index'
    ) ||
    window.location.pathname === '/';


  /* ==========================================
     ATUALIZA ESTADO VISUAL DO MENU
  ========================================== */

  function updateHeader() {

    const isSticky =
      header.dataset.stickyState ===
      'active';


    /*
     * acompanha o estado sticky
     * do header do Fabric
     */

    menu.classList.toggle(
      'is-scrolled',
      isSticky
    );


    /*
     * páginas internas:
     * menu escuro o tempo todo
     */

    menu.classList.toggle(
      'is-dark',
      !isHome
    );

  }


  /* primeira execução */

  updateHeader();


  /* ==========================================
     OBSERVA MUDANÇA DO HEADER
  ========================================== */

  const observer =
    new MutationObserver(
      updateHeader
    );


  observer.observe(
    header,
    {
      attributes: true,

      attributeFilter: [
        'data-sticky-state'
      ]
    }
  );


});